import React, { useContext, useEffect, useState } from "react";
import { GlobalState } from "../Data/Context";
import Calendar from "react-calendar";
import { Container } from "reactstrap";
import "react-calendar/dist/Calendar.css";
import { useNavigate } from "react-router-dom";
import TransactionsFolder from "./Transactions";
import { productArr } from "./Products";
import { BecomeAgent } from "./Settings";

const Dashboard = ({ usersArr }) => {
	let { setStateName, auth, usecase } = useContext(GlobalState);
	// const navigate = useNavigate();

	let [isRequest, setIsRequest] = useState(""),
		closeRequest = () => {
			setIsRequest("");
		};
	//  navigate = useNavigate();
	useEffect(() => {
		setStateName("dashboard analysis");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="bg-white aboutScreen">
			<Container className="py-5">
				<div className="row mx-0 w-100">
					<div className="col-md-8">
						<FourBoxBar list={usersArr} />
						{!auth?.user?.isAdmin && (
							<div className="d-flex flex-column flex-md-row">
								{auth?.user?.privilege !== "reseller" &&
									usecase?.usecase?.resellerUpgrade === "enable" && (
										<button
											onClick={() => setIsRequest("reseller")}
											className="btn btn-primary1
								text-capitalize px-md-4 px-2 mx-1 mx-md-3 py-3 mb-3 mb-md-0 fontReduce2 text-white">
											become a reseller
										</button>
									)}
								{auth?.user?.privilege !== "topuser" &&
									usecase?.usecase?.topuserUpgrade === "enable" && (
										<button
											onClick={() => setIsRequest("topuser")}
											className="btn btn-primary1
								text-capitalize px-md-4 px-2 mx-1 mx-md-3 py-3 fontReduce2 text-white">
											become a topuser
										</button>
									)}
								{["Teetop Digitals", "TEETOP DIGITALS"]?.includes(
									process.env.REACT_APP_NAME
								) &&
									auth?.user?.privilege !== "standalone" &&
									usecase?.usecase?.standaloneUpgrade === "enable" && (
										<button
											onClick={() => setIsRequest("standalone")}
											className="btn btn-primary1
								text-capitalize px-md-4 px-2 mx-1 mx-md-3 py-3 fontReduce2 text-white">
											become a standalone
										</button>
									)}
							</div>
						)}
						<ProductList />
					</div>
					<MainCalenderComponent />
				</div>
				<TransactionsFolder />
				<BecomeAgent isOpen={isRequest} back={closeRequest} />
			</Container>
		</div>
	);
};

export default Dashboard;

export const MainCalenderComponent = () => {
	return (
		<>
			<div className="col-md-4 d-none d-md-flex flex-column">
				<CalenderComponent css="darkPurple rounded20 border-0 p-3 text-white w-100" />
			</div>
		</>
	);
};

export const CalenderComponent = ({ css }) => {
	return (
		<>
			<div className="d-flex w-100">
				<Calendar className={css} showWeekNumbers={true} calendarType="US" />
			</div>
		</>
	);
};

export const FourBoxBar = ({ list }) => {
	let navigate = useNavigate();
	return (
		<>
			<div className="row mx-0 g-2 g-md-4 mb-4 mb-md-5">
				{list?.map((item, index) => (
					<div className="col-6 dashHeight dashHeight2" key={index}>
						<div
							className="row mx-0 p-2 p-md-3 eachProduct rounded20 text-white h-100"
							onClick={() => (item?.link ? navigate(item?.link) : {})}
							style={{
								background: item?.color,
							}}>
							<div className="col-md my-auto d-flex">
								<img
									src={item?.icon}
									className="img-fluid mx-auto"
									alt="Icon"
								/>
							</div>
							<div className="col-md my-auto text-center">
								<p className="text2 text2Big m-0">{item?.number}</p>
								<h6 className="text-capitalize fontReduceBig">{item?.name}</h6>
							</div>
							{item.name === "wallet balance" && (
								<p className="col-12 tw-font-bold m-0">Fund Wallet</p>
							)}
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export const ProductList = () => {
	let { auth } = useContext(GlobalState);
	let [state, setState] = useState([]),
		navigate = useNavigate();

	useEffect(() => {
		setState(
			!["reseller", "standalone"]?.includes(auth?.user?.privilege)
				? productArr?.filter(it=> it?.show)?.filter(item => item?.link !== "/cgwallet")
				: productArr?.filter(it=> it?.show)
		);
	}, [auth?.user]);

	return (
		<div className="py-3 py-md-4">
			<div className="row g-4 mx-0">
				{state?.map((item, i) => (
					<div className="col-4 px-2 p-md-3 text-center" key={i}>
						<div
							onClick={() =>
								navigate(
									item?.link?.includes("converter")
										? item?.link
										: `/products${item?.link}`
								)
							}
							className="shadow2 p-3 py-md-5 eachProduct rounded20 h-100 d-flex align-items-center justify-content-center">
							<div className="d-flex w-100 flex-column align-items-center justify-content-center">
								<div className="mb-3">{item?.icon}</div>
								<h6 className="Lexend textTrunc textTrunc2 fontReduce2">
									{item?.name}
								</h6>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
